export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const GOOGLE_AUTH_SUCCESS = "GOOGLE_AUTH_SUCCESS";
export const GOOGLE_AUTH_REQUEST = "GOOGLE_AUTH_REQUEST";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const RESET_REQUEST = "RESET_REQUEST";
export const RESET_PASSWORD = "RESET_PASSWORD";
